import { IconCalendar, IconChecklist, IconChevronLeft, IconChevronRight, IconDisabled, IconEdit, IconSearch } from '@tabler/icons-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import { useNavigate } from 'react-router-dom';

import { IconReload } from '@tabler/icons-react';
import useKarat from '../features/useKarat';
import Input from '../../components/Input';
import { getAuthorizationHeader, http } from '../../config/http';
import { DinamicTitle } from '../../utils/DinamicTitle';
import Layouts from '../../layouts/Layouts';
import DetailBarangPenjualan from '../Transaksi/DetailBarangPenjualan';
import ModalTransaksiTertunda from './ModalTransaksiTertunda';
import { toast } from 'react-toastify';
import ModalProsesTransaksiTertunda from './ModalProsesTransaksiTertunda';
import LoadingIndicator from '../../components/LoadingIndicator';
import { Tooltip } from 'antd';
import { IconEye } from '@tabler/icons-react';
import { IconTrash } from '@tabler/icons-react';
import ModalKonfirmasiHapusTransaksi from './ModalKonfirmasiHapusTransaksi';

const ListTransaksiTertunda = () => {
  const navigate = useNavigate();
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  const [trxPenjualan, setTrxPenjualan] = useState([]);
  // console.log(trxPenjualan)
  const [openLoading, setOpenLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectCabang, setSelectCabang] = useState([]);
  const [idCabang, setIdCabang] = useState(0);
  const [idKategori, setIdKategori] = useState(0);
  const [kategori, setKategori] = useState([]);

  const [openCalender, setOpenCalender] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  // const [totalHargaPenjualan, setTotalHargaPenjualan] = useState(0);
  // const [totalHargaFilter, setTotalHargaFilter] = useState(0);

  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [search, setSearch] = useState('');

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * itemsPerPage;
  const [isProses, setIsProses] = useState(0);

  async function getTrxTertunda() {
    setLoading(true);
    await http
      .get(
        `/transaksi_tertunda${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${(idCabang === 0 || idCabang === '') ? `` : `&cabang=${idCabang}`}
        ${(idKategori === 0 || idKategori === '') ? `` : `&kategori=${idKategori}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${karatOptionId === '' ? '' : `&karat=${karatOptionId}`}${berat === '' ? '' : `&berat=${berat}`}${isProses === '' ? '&status=0' : `&status=${isProses}`}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setTrxPenjualan(res.data.data.data);
        setCurrentPage(res.data.data.current_page);
        setItemsPerPage(res.data.data.per_page);
        setLastPage(res.data.data.last_page);
        return res.data.data;
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }
  useEffect(() => {
    getTrxTertunda();
  }, [
    idCabang,
    idKategori,
    search.length >= 12 ? search : '',
    awal,
    akhir,
    startDate,
    endDate,
    currentPage,
    navigate,
    karatOptionId,
    berat,
    isProses,
  ]);

  const [isOpenDetailTransaksiTertunda, setIsOpenDetailTransaksiTertunda] = useState(false);
  let [isOpenLoadingDetail, setIsOpenLoadingDetail] = useState(false);
  const [detailItemTransaksiTertunda, setDetailTransaksiTertunda] = useState(null);
  function closeDetailTransaksiTertunda() {
    setIsOpenDetailTransaksiTertunda(false);
  }
  function openDetailTransaksiTertunda() {
    setIsOpenDetailTransaksiTertunda(true);
  }
  async function getDetailTransaksiTertunda(id) {
    setIsOpenLoadingDetail(true);
    await http
      .get(`/transaksi_tertunda/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailTransaksiTertunda(res.data.data);
        openDetailTransaksiTertunda();
      });
    setIsOpenLoadingDetail(false);
  }

  const [loadingHapus, setLoadingHapus] = useState(false);
  const [isOpenModalTTH, setIsOpenModalTTH] = useState(false);
  const [idTerhapus, setIdTerhapus] = useState('');

  function closeModalTTH() {
    setIsOpenModalTTH(false);
  }
  function openModalTTH(id) {
    setIsOpenModalTTH(true);
    setIdTerhapus(id)
  }


  async function handleHapusTransaksiTertunda() {
    setLoadingHapus(true);
    await http.delete(`/transaksi_tertunda/${idTerhapus}`).then((res) => {
      toast.success('Data berhasil dihapus', { autoClose: 600, });
      closeModalTTH();
      getTrxTertunda();
      return res.data;
    }).catch((err) => {
      console.log(err)
      toast.warning('Terjadi kesalahan di server', { autoClose: 600, });
    });
    setLoadingHapus(false);
  }


  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    async function getCabangSelect() {
      await http
        .get(`cabang?is_toko=1`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setSelectCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getCabangSelect();
  }, [navigate]);

  useEffect(() => {
    async function getKategori() {
      await http
        .get('/kategori', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setKategori(res.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getKategori();
  }, []);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }
  DinamicTitle('List Transaksi Penggarus || Komaladewi');
  const [isOpenModalTransaksiTertunda, setIsOpenModalTransaksiTertunda] = useState(false);
  const [idTransaksiTertunda, setIdTransaksiTertunda] = useState('');
  function openModalTransaksiTertunda(id) {
    setIsOpenModalTransaksiTertunda(true);
    setIdTransaksiTertunda(id);
  }
  function closeModaTransaksiTertunda() {
    setIsOpenModalTransaksiTertunda(false);
  }
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
      setSelectAll(false);
    } else {
      const allIds = trxPenjualan.map((bt) => bt.item.id);
      setSelectedIds(allIds);
      setSelectAll(true);
    }
  };
  const handleSingleSelect = (id) => {
    const isSelected = selectedIds.includes(id);
    if (isSelected) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };
  const [isOpenProses, setIsOpenProsess] = useState(false);
  function closeModalProses() {
    setIsOpenProsess(false)
  }
  function reloadData() {
    getTrxTertunda();
  }
  function handleOpenModalProses() {
    if (selectedIds.length !== 0) {
      setIsOpenProsess(true)
    } else {
      toast.error('Pastikan telah memilih data dulu', { autoClose: 600, })
    }
  }
  return (
    <Layouts
      title={'List Transaksi Penggarus'}
      compFilter={
        <div className="flex items-center gap-2">
          <button
            onClick={handleOpenModalProses}
            disabled={isOpenProses}
            className="px-3 py-2 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-lg text-sm font-medium shadow-sm hover:shadow transition-all duration-200 flex items-center gap-1.5"
          >
            <IconChecklist size={18} />
            Proses
          </button>
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              onClick={() => setOpenCalender(!openCalender)}
              className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-lg cursor-pointer transition-all duration-200 shadow-sm hover:shadow"
              title="Filter Tanggal"
            >
              <IconCalendar size={20} />
            </div>
            <div tabIndex={0} className="dropdown-content menu -right-36 p-2 shadow-lg bg-white dark:bg-slate-800 rounded-lg z-50">
              <DateRange ranges={[selectionRange]} onChange={handleSelect} />
            </div>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
            title="Reload"
          >
            <IconReload size={20} />
          </button>
        </div>
      }
    >
      {isOpenLoadingDetail && <LoadingIndicator />}
      <ModalTransaksiTertunda
        getTrxPenjualan={() => window.location.reload()}
        isOpenModalTransaksiTertunda={isOpenModalTransaksiTertunda}
        closeModaTransaksiTertunda={closeModaTransaksiTertunda}
        setOpenLoading={setOpenLoading}
        idTransaksiTertunda={idTransaksiTertunda}
      />
      <ModalProsesTransaksiTertunda
        closeModalRestore={closeModalProses}
        isOpenModalRestore={isOpenProses}
        reloadData={() => window.location.reload()}
        selectedIds={selectedIds}
      />
      <div className=" ">
        <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-amber-100/60 dark:border-slate-700/60 px-3 py-2.5 transition-colors">
          <div className="flex items-center gap-2 w-full overflow-x-auto scrollbar-none">
            <div className="flex items-center gap-1.5 flex-shrink-0">
              {/* ETALASE */}
              <select
                onChange={(e) => setIdCabang(e.target.value)}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">ETALASE</option>
                {selectCabang.map((cb) => (
                  <option value={cb.id} key={cb.id}>
                    {cb.nama_cabang}
                  </option>
                ))}
              </select>

              {/* KATEGORI */}
              <select
                onChange={(e) => setIdKategori(e.target.value)}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">KATEGORI</option>
                {kategori.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nama_kategori}
                  </option>
                ))}
              </select>

              {/* KARAT */}
              <select
                onChange={(e) => setKaratOptionId(e.target.value)}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">KARAT</option>
                {karatOption.map((kto) => (
                  <option key={kto} value={kto}>
                    {kto}
                  </option>
                ))}
              </select>

              {/* STATUS */}
              <select
                onChange={(e) => setIsProses(e.target.value)}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">STATUS</option>
                <option value="1">Telah diproses</option>
                <option value="0">Belum diproses</option>
              </select>

              {/* Berat Search */}
              <div className="flex items-center gap-1 w-44">
                <Input
                  onChange={(e) => setFilterBerat(e.target.value)}
                  placeholder="Cari Berat"
                  className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none w-full"
                />
                <button
                  onClick={filterBeratBarang}
                  className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 p-2 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 flex-shrink-0"
                >
                  <IconSearch size={18} />
                </button>
              </div>

              {/* Selection Count */}
              {selectedIds.length > 0 && (
                <div className="flex items-center gap-1.5 px-2.5 py-1.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700/50 rounded-lg">
                  <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 whitespace-nowrap">
                    Dipilih: <span className="text-amber-600 dark:text-amber-300">{selectedIds.length}</span>
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="border-t">
          <ModalKonfirmasiHapusTransaksi
            submitProses={handleHapusTransaksiTertunda}
            isOpenModalProses={isOpenModalTTH}
            closeModaProses={closeModalTTH}
            isLoadingSubmit={loadingHapus}
          />
          <DetailBarangPenjualan
            isTertunda
            label={'Transaksi Penggarus'}
            checkBerat={checkBerat}
            closeModal={closeDetailTransaksiTertunda}
            detailPenjualan={detailItemTransaksiTertunda}
            isOpen={isOpenDetailTransaksiTertunda}
          />
          {openLoading && (
            <LoadingIndicator />
          )}
          <div className="relative overflow-x-auto overflow-hidden mx-3 mt-3 mb-16 rounded-xl border border-slate-200/60 dark:border-slate-700/60 shadow-sm">
            <table className="w-full text-sm text-left dark:text-slate-300">
              <thead>
                <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    No
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Kode Barang
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Nama Barang
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Berat | Karat
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Harga
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Rata | Gram
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Kasir
                  </th>
                  <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Tanggal
                  </th>
                  <th scope="col" className="py-3 px-3 text-center text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                    Aksi
                  </th>
                  <th scope="col" className="py-3 px-3 text-center">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all"
                      onChange={handleSelectAll}
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700 bg-white dark:bg-slate-900">
                {loading ? (
                  <tr>
                    <td colSpan={10} className="py-12">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-8 h-8 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
                        <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {trxPenjualan.map((trx, i) => {
                      return (
                        <tr
                          key={trx.id}
                          onClick={(e) => {
                            e.stopPropagation();
                            getDetailTransaksiTertunda(trx.id);
                          }}
                          className="group hover:bg-amber-50/50 dark:hover:bg-slate-800/60 cursor-pointer transition-colors"
                        >
                          <td className="py-2.5 px-3 text-slate-500 dark:text-slate-400 text-xs font-medium">
                            {startIndex + i + 1}.
                          </td>
                          <td className="py-2.5 px-3 text-amber-700 dark:text-amber-400 font-semibold text-sm truncate">
                            {trx.item.kode_item}
                          </td>
                          <td className="py-2.5 px-3 text-slate-800 dark:text-slate-200 font-medium text-sm truncate">
                            {trx.item?.jenis_kategori?.nama_jenis}{' '}
                            {trx.is_refund === false ? (
                              ``
                            ) : (
                              <span className="text-red-500 text-xs font-light ml-1 px-1.5 py-0.5 bg-red-50 dark:bg-red-900/20 rounded-md border border-red-200 dark:border-red-900/50">
                                dikembalikan
                              </span>
                            )}{' '}
                          </td>

                          <td className="py-2.5 px-3 text-slate-600 dark:text-slate-300 text-sm">
                            {trx.item?.berat} gr | {trx.item?.karat} krt
                          </td>
                          <td className="py-2.5 px-3 text-slate-800 dark:text-slate-200 font-medium text-sm">
                            Rp {numberWithCommas(trx.total_harga === undefined ? '0' : trx.total_harga)}
                          </td>
                          <td className="py-2.5 px-3 text-slate-600 dark:text-slate-300 text-sm">
                            Rp{' '}
                            {numberWithCommas(
                              trx.total_harga === undefined ? '0' : Math.round(trx.total_harga / trx.item?.berat),
                            )}{' '}
                            / gr
                          </td>
                          <td className="py-2.5 px-3 text-slate-600 dark:text-slate-300 text-sm">
                            {trx.user?.name}
                          </td>
                          <td className="py-2.5 px-3 text-slate-500 dark:text-slate-400 text-sm">
                            {trx.created_at}
                          </td>
                          <td className="py-2.5 px-3 text-center">
                            <div className="flex items-center justify-center gap-1.5">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  getDetailTransaksiTertunda(trx.id);
                                }}
                                className="w-7 h-7 rounded-md flex items-center justify-center text-emerald-600 bg-emerald-50 hover:bg-emerald-500 hover:text-white dark:text-emerald-400 dark:bg-emerald-500/20 dark:hover:bg-emerald-500 dark:hover:text-white transition-all shadow-sm hover:shadow"
                                title="Lihat Detail"
                              >
                                <IconEye size={16} stroke={1.5} />
                              </button>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!trx.is_proses) openModalTTH(trx.id);
                                }}
                                className={`w-7 h-7 rounded-md flex items-center justify-center transition-all shadow-sm hover:shadow ${trx.is_proses
                                  ? 'text-slate-300 bg-slate-50 dark:text-slate-700 dark:bg-slate-800/50 cursor-not-allowed'
                                  : 'text-red-600 bg-red-50 hover:bg-red-500 hover:text-white dark:text-red-400 dark:bg-red-500/20 dark:hover:bg-red-500 dark:hover:text-white'
                                  }`}
                                title="Hapus"
                              >
                                <IconTrash size={16} stroke={1.5} />
                              </button>
                            </div>
                          </td>
                          <td className="py-2.5 px-3 text-center">
                            {trx.is_proses ? (
                              <span className="text-xs font-bold uppercase tracking-wider text-emerald-500 bg-emerald-50 dark:bg-emerald-900/20 px-2 py-1 rounded-md border border-emerald-100 dark:border-emerald-900/50">
                                Selesai
                              </span>
                            ) : (
                              <input
                                checked={selectedIds.includes(trx.item.id)}
                                onChange={() => handleSingleSelect(trx.item.id)}
                                className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all"
                                type="checkbox"
                                onClick={(e) => e.stopPropagation()}
                              />
                            )}
                          </td>
                          {/* <td className="px-[6px] py-1 whitespace-nowrap font-normal">
                                <input
                                  checked={selectedItems.includes(item)}
                                  onChange={(event) => handleCheckboxChange(event, item)}
                                  type="checkbox"
                                  checked={isCheckedItems[index]}
                                  onChange={handleCheck}
                                  data-index={index}
                                  className="cursor-pointer checkbox checkbox-primary w-4 h-4 border-slate-700 rounded"
                                />
                              </td> */}
                          {/* <td className="px-2 py-0 whitespace-nowrap border-b border-gray-200  text-[13px]">
                                <p>{trx.is_refund ? (
                                    <Tooltip title="Refuned">
                                    <div className='bg-red-700 w-4 h-4 rounded-full'/>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="not Refund">
                                    <div className='bg-green-700 w-4 h-4 rounded-full'/>
                                  </Tooltip>
                                )}</p>
                              </td> */}
                        </tr>
                      )
                    })}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="bg-white/80 dark:bg-slate-900/80 border-t border-slate-200 dark:border-slate-700/60 bottom-0 left-0 py-3.5 w-full absolute shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <div className="items-center flex justify-end space-y-2 text-sm sm:space-y-0 sm:space-x-4 mr-6 sm:flex">
          <span className="block text-slate-600 dark:text-slate-400 font-medium">
            Halaman <span className="text-amber-600 dark:text-amber-400 font-bold">{currentPage}</span> dari <span className="font-bold">{lastPage}</span>
          </span>
          <div className="flex gap-1.5">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage <= 1}
              title="Sebelumnya"
              type="button"
              className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-lg shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:border-amber-300 disabled:opacity-40 transition-all"
            >
              <IconChevronLeft size={18} />
            </button>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage >= lastPage}
              title="Selanjutnya"
              type="button"
              className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-lg shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:border-amber-300 disabled:opacity-40 transition-all"
            >
              <IconChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </Layouts>
  );
};

export default ListTransaksiTertunda;
